import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { centsToInput } from "@/lib/format";
import { EntryForm } from "./EntryForm";

export function EditEntryDialog({ entry, onClose, onSaved }) {
  if (!entry) return null;
  const initial = {
    type: entry.type, date: entry.date, amount: centsToInput(entry.amount_cents), category_id: entry.category_id,
    vendor: entry.vendor || "", description: entry.description || "", payment_method: entry.payment_method,
  };
  const extra = { id: entry.category_id, name: entry.category_name, type: entry.type };
  const save = async (payload) => {
    const { data } = await api.put(`/transactions/${entry.id}`, payload);
    toast.success("Entry updated");
    onSaved(data);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto rounded-2xl bg-card" data-testid="edit-entry-dialog">
        <DialogHeader><DialogTitle className="font-heading text-xl">Edit entry</DialogTitle></DialogHeader>
        <EntryForm key={entry.id} initial={initial} extraCategory={extra} submitLabel="Save changes" onSubmit={save} idPrefix="edit-entry" />
      </DialogContent>
    </Dialog>
  );
}
